import React from "react";
import { Box, Typography, TextareaAutosize, Button } from "@mui/material";
import BaseInput from "../components/all-inputs/BaseInput";
import { useNavigate } from "react-router-dom";

function Deactivate() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/deactivate/result");
  };
  return (
    <Box
      width="100%"
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        width="418px"
        bgcolor="#FAFAFA"
        display="flex"
        flexDirection="column"
        alignItems="center"
        borderRadius={3}
        p={3}
      >
        <Typography variant="h1" mb={4} textAlign="center">
          آیا می مطمئنید که می خواهید حساب کاربری خود را غیر فعال کنید ؟
        </Typography>
        <Typography variant="h2" mb={4} textAlign="center">
          {" "}
          در صورتی که مطمئنید ایمیل خود را وارد کنید
        </Typography>
        <BaseInput
          width={"335px"}
          isSignIn={true}
          isDeactivate={true}
          placeholder={"email : hi@hi.com"}
        />
        <Box
          display="flex"
          justifyContent="center"
          flexDirection={{ xs: "column-reverse", sm: "row", md: "row" }}
          alignItems="center"
          width="100%"
          mt={4}
        >
          <Button variant="m2">انصراف</Button>
          <Button
            variant="m1"
            sx={{ width: "165px", ml: { xs: 0, md: 2 }, my: { xs: 1, md: 0 } }}
            onClick={handleClick}
          >
            غیر فعالسازی
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Deactivate;
